import React, { cloneElement, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { TYPE, URL } from '../../constant';
import { mathpidLogAPICall } from '../../redux/logData';
import { appKillOnOff, getAge } from '../../utils/utilityEtc';
import { useAsideState, useLearningHistory, useSound, useUserInfo } from '../../hooks';
import AibarosamGroupOne from './aibarosam/AibarosamGroupOne';
import AibraosameGroupTwo from './aibarosam/AibraosameGroupTwo';
import SelectLearningGMV2 from './SelectLearningGMV2';
import lottieEventListener from '../../utils/lottieEventListener';

function AibarosamInit(props) {
  const history = useHistory();
  const logDispatch = useDispatch();

  const { info }  = useUserInfo();
  const { setAsideState } = useAsideState();
  const { learningHistoryInfo } = useLearningHistory();
  const { setSound, playSound, clearSound } = useSound();

  const [age, setAge] = useState(null);

  useEffect(() => {
    console.log('***** 메인 페이지')

    initiFunc();
    // 앱 뒤로가기 종료 on/off
    appKillOnOff('N');
    appKillOnOff('Y');

    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',  
      screenCode: 'scr_0000_0000',
    }));
  }, []);

  useEffect(() => {
    if (!info.learnerBirth) return;
    const age = getAge(info.learnerBirth);
    setAge(age);
    
  }, [info]);

  const initiFunc = useCallback(() => {
    clearSound();
    setSound({
      src: `${process.env.PUBLIC_URL}/static/audio/lc_01_02.ogg`,
    });

    lottieEventListener({
      id: "ani_course",
      path: "/static/json/img_lc_01_02_01.json"
    });

    lottieEventListener({
      id: "ani_topic",
      path: "/static/json/img_lc_01_02_02.json"
    });

  }, [clearSound, setSound]);

  const handlePage = useCallback((page) => {
    let tab = "home";
    // 주제학습
    if (page === URL.TOPIC_LEARNING) {
      tab = "topic";
      localStorage.setItem("learning.id", TYPE.LEARNING.TOPIC);
      // 진단테스트
    } else if (page === URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.ENTER_LEARNER_DATA) {
      tab = "course";
      // 진단테스트를 진행한 경우
      if (learningHistoryInfo.isCompleteAIDiagnosis === 'Y') {
        page = URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT
      }
    }
    if (page !== URL.INTRODUCTION && page !== URL.STAR_SHOP_HISTORY) {
      playSound();
      setAsideState({ tab });
    }
    history.push(page);
  });

  const component = useMemo(() => {
    if (!String(age)) return;

    if ((age < 7) || (age >=7 && age <= 9)) return <AibarosamGroupOne />
    else if (age >= 10 && age <= 12) return <AibraosameGroupTwo />
    else if (age >= 13) return <SelectLearningGMV2 />  }, [age])

  return cloneElement(
    component ? component : <React.Fragment />,
    {
      handlePage: handlePage
    }
  )
}

export default AibarosamInit;